import React from 'react';
import defaultLoader from '../../../assets/img/loaders/loader.svg';

const Loader = ({ img, width }) => {
    if (!width) {
        width = '70px';
    }

    if (!img) {
        img = defaultLoader;
    }

    return <img src={img} width={width} alt="" />;
}
 
export default Loader;